import * as Yup from "yup";

export enum RoleFormHeader {
  add = "Add Role",
  edit = "Edit Role",
}

export const StatusOptions = ["Active", "Inactive"] as const;

export const RoleFormSchema = Yup.object({
  status: Yup.string()
    .oneOf([...StatusOptions])
    .defined("Required"),
  name: Yup.string().required("Required"),
  description: Yup.string(),
});

export type RoleFormType = Yup.TypeOf<typeof RoleFormSchema>;
